require('es6-promise').polyfill();
import { Dispatch } from "redux";
import axios from 'axios';
import { IAppState } from "../../classes/app";
import { IAppAction } from "../../classes/action";
import { ActionType } from "./actiontype";
import { IListItem } from "../../classes/list-item";
import * as moment from 'moment';
import { ISearchResultsDTO } from "../../classes/search-results-dto";
export function upsertFilter(filterProperty: string, value: string): IAppAction {
    return {
        type: ActionType.UPSERT_FILTER,
        value: {
            property: filterProperty,
            value: value
        }
    }
}
export function NextMonth(): IAppAction {
    return {
        type: ActionType.NEXT_MONTH,

    }
}
export function PrevMonth(): IAppAction {
    return {
        type: ActionType.PREV_MONTH,

    }
}

export function removeFilter(filterProperty: string): IAppAction {
    return {
        type: ActionType.REMOVE_FILTER,
        value: filterProperty
    }
}

export function removeAllFilters(): IAppAction {
    return {
        type: ActionType.REMOVE_ALL_FILTERS
    }
}

export function setSpecialtiesFilter(hide: boolean): IAppAction {
    return {
        type: ActionType.SET_SPECIALTIES_FILTER,
        value: hide
    }
}

export function setZipOrCityFilter(hide: boolean): IAppAction {
    return {
        type: ActionType.SET_ZIP_OR_CITY_FILTER,
        value: hide
    }
}

export function setGenderFilter(hide: boolean): IAppAction {
    return {
        type: ActionType.SET_GENDER_FILTER,
        value: hide
    }
}

export function setLanguageFilter(hide: boolean): IAppAction {
    return {
        type: ActionType.SET_LANGUAGE_FILTER,
        value: hide
    }
}

export function setProviderDesignationFilter(hide: boolean): IAppAction {
    return {
        type: ActionType.SET_PROVIDER_DESIGNATION_FILTER,
        value: hide
    }
}

export function setHospitalPracticeFilter(hide: boolean): IAppAction {
    return {
        type: ActionType.SET_HOSPITAL_PRACTICE_FILTER,
        value: hide
    }
}

export function setNetworkFilter(hide: boolean): IAppAction {
    return {
        type: ActionType.SET_NETWORK_FILTER,
        value: hide
    }
}

export function setPrintButton(show: boolean): IAppAction {
    return {
        type: ActionType.SET_PRINT_BUTTON,
        value: show
    }
}

export function setCityFilter(show: boolean): IAppAction {
    return {
        type: ActionType.SET_CITY_FILTER,
        value: show
    }
}

export function setSearchWithinTitle(title: string): IAppAction {
    return {
        type: ActionType.SET_SEARCHWITHIN_TITLE,
        value: title
    }
}

export interface EveryXWeek {
    everyx: number,
    weekday: string[]
}
export interface NthDayOfMonth {
    nth: string,
    day: string
}
export function fetchEvents(month: moment.Moment, query = "", zipOrCity = "" , eventType="") {
    return (dispatch: Dispatch) => {

        const startDay = month.clone().startOf('month').startOf('week');
        const endDay = month.clone().endOf('month').endOf('week');
        dispatch(requestEvent());
        axios.get<ISearchResultsDTO>(`/api/SearchResult/GetEvents?startdate=${startDay.format("YYYY-MM-DD")}&enddate=${endDay.format("YYYY-MM-DD")}&QueryValue=${query}&ziporcity=${zipOrCity}&eventtype=${eventType}`).then(response => {
            const listing = response.data.currentPageItems;
            
            const dates = listing.map(item => moment(item.eventTime.toLocaleString()));
            const everyXWeek: EveryXWeek[] = listing.map(item =>
            {
                if (item.recurrence) {
                    return {
                        everyx: item.everyXWeek,
                        weekday: item.recurrence,
                        
                    }
                }
                
            }).reduce((a, b) => a.concat(b), []).filter(x=> x!==undefined);

            const nthDayOfMonth: NthDayOfMonth[] = listing.map(item => {
                if (item.nthWeek && item.nthWeekDay) {
                    return {
                        nth: item.nthWeek,
                        day: item.nthWeekDay,

                    }
                }

            }).reduce((a, b) => a.concat(b), []).filter(x => x !== undefined);;
            
            dispatch(storeEvent(dates, everyXWeek, nthDayOfMonth));

        }).catch(err => {
            dispatch(errorFilterOptions(err));
        });
    }
}


export function storeFilterOptions(filterOptionEndPoint: string) {
    return (dispatch: Dispatch, getState: () => IAppState) => {
        dispatch(requestOptions());
        axios.get(filterOptionEndPoint).then(response => {
            dispatch(storeOptions(response.data));
        }).catch(err => {
            dispatch(errorFilterOptions(err));
        });
    }
}

export function updateFilterOptions(filters) {
    return {
        type: ActionType.UPDATE_FILTERS,
        value: filters
    }
}

function requestEvent(): IAppAction {
    return {
        type: ActionType.REQUEST_EVENTS
    }
}

function storeEvent(response,everyXWeek,nthDayOfMonth): IAppAction {
    return {
        type: ActionType.STORE_EVENTS,
        value: {
            response: response,
            everyXWeek: everyXWeek,
            nthDayOfMonth: nthDayOfMonth
        }

    }
}

function requestOptions(): IAppAction {
    return {
        type: ActionType.REQUEST_FILTER_OPTIONS
    }
}

function storeOptions(response): IAppAction {
    return {
        type: ActionType.STORE_FILTER_OPTIONS,
        value: response
    }
}

function errorFilterOptions(err): IAppAction {
    return {
        type: ActionType.ERROR_FILTER_OPTIONS,
        value: err
    }
}